export default __webpack_public_path__ + "static/ecosistema_TEC-Edutoolkit-dedf35f1652ee64b4b4545d977a86451.png";